module.exports = __webpack_public_path__ + "static/media/geowash-mobile-screens.5fee698c.png";